module.exports = __webpack_public_path__ + "static/img/moreCloud.952b84a.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/img/moreCloud.png
// module id = IA1k
// module chunks = 0